import { FC } from "react"
import { useAppSelector } from "store/index"
import { AppSelectors } from "store/slices/appSlice"
import { useLoad } from "hooks/useLoad.tsx"
import LoaderScreen from "ui/loader-screen"
import { loaderLogo, darkLoaderLogo } from "assets/icons"
import { loaderBg, bossStartLocation } from "assets/images"

export const Loader: FC = () => {
  const progress = useLoad()
  const isUnder = useAppSelector(AppSelectors.selectIsUnder())

  return (
    <LoaderScreen
      variant={isUnder ? "dark" : "default"}
      backgroundImage={isUnder ? bossStartLocation : loaderBg}
      logo={isUnder ? darkLoaderLogo : loaderLogo}
      progress={progress}
    />
  )
}
